import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { NdSklad } from '@/modules/sklad/ndSklad';
import { NdCenik } from '@/modules/sklad/ndCenik';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { editMutations, editActions } from './types';

const edit = {
	EditDat: null as Date | null,
	EditPracId: null as number | null,
	EditPracIdText: null as string | null,
	NdNr: null as string | null,
	NdPopis: null as string | null,
	NdTyp: null as string | null,
	NdPrumernaSkladovaPc: null as number | null,
	NdKdc: null as number | null,

	NdakceId: null as number | null,
	PcPevna: null as number | null,
	VstupDat: null as Date | null,
	VstupPracId: null as number | null,
	VstupPracIdText: null as string | null,
	VyrobekndOzn: null as string | null,
	ZaznamId: null as number | null,

	Text: null as string | null, // TODO: rozsirit BE DTO
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		VyrobekndOzn: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {
		async [editActions.ND_SKLAD_POLOZKY_MAPPER]({ state, commit }, { data }) {
			const dataForMutation = {
				NdPrumernaSkladovaPc: null as number | null,
				VyrobekndOzn: null as string | null,
				NdKdc: null as number | null,
				NdNr: null as string | null,
				Text: null as string | null,
			};
			if (data.value && data.ndnr) {
				const { data: ndSkladEntity } = await NdSklad.apiProvider.entity(data.value);
				dataForMutation.NdNr = data.ndnr;
				dataForMutation.Text = data.text;
				dataForMutation.VyrobekndOzn = ndSkladEntity.VyrobekndOzn;
				const prumernaSkladovaPcFilter = {
					vyrobekndOzn: ndSkladEntity.VyrobekndOzn,
					ndNr: data.ndnr,
					skladOzn: state.props.filter.skladOzn,
				};
				const { data: prumernaSkladovaPc } = await NdSklad.apiProvider.prumernaSkladovaPc(prumernaSkladovaPcFilter);
				dataForMutation.NdPrumernaSkladovaPc = prumernaSkladovaPc;
				const { data: ndCenik } = await NdCenik.apiProvider.entityByKey({
					vyrobekndOzn: ndSkladEntity.VyrobekndOzn,
					ndNr: data.ndnr,
				});
				dataForMutation.NdKdc = ndCenik.CenaGd;
			} else {
				dataForMutation.NdPrumernaSkladovaPc = null;
				dataForMutation.NdKdc = null;
				dataForMutation.NdNr = null;
				dataForMutation.Text = null;
			}

			commit(editMutations.ND_SKLAD_POLOZKY_MAPPER, { data: dataForMutation });
		},
	},
	extraMutations: {
		[editMutations.ND_SKLAD_POLOZKY_MAPPER](state, { data }) {
			state.edit.NdNr = data.NdNr;
			state.edit.Text = data.Text;
			state.edit.VyrobekndOzn = data.VyrobekndOzn;
			state.edit.NdPrumernaSkladovaPc = data.NdPrumernaSkladovaPc;
			state.edit.NdKdc = data.NdKdc;
		},
	},
	extraGetters: {},
	props: {
		filter: {
			ndakceId: null as number | null,
			skladOzn: null as string | null,
			text: null as string | null,
		},
		mode: null,
	},
});
